import store from "../store";

export function getTodayComplaintCount() {
  store.dispatch({ type: "GET_TODAY_COMPLAINT_COUNT" });
}

export function getComplaintsCount(from, to, allowedZones) {
  store.dispatch({ type: "GET_COMPLAINTS_COUNT", payload: { from, to, allowedZones } });
}
